import React, { useState } from 'react';
import { Card, Button } from './ui';
import { ShieldCheck, Plus, Minus, Scale, Clock, Lock, Zap, CreditCard } from 'lucide-react';
const CHECKOUT_URL = 'https://cuerpo-en-calma.impultienda.ar/checkout';
export function Guarantee() {
  return <section className="py-10 px-4" data-id="element-184" data-mp="2wkmo6ben9krq">
      <div className="max-w-3xl mx-auto" data-id="element-185" data-mp="2wloc3ggre1qv">
        <Card className="bg-brand-50 border-brand-200 text-center relative overflow-hidden" data-id="element-186" data-mp="2wmr3dphzu67b">
          <div className="absolute -right-10 -top-10 text-brand-200/60" data-id="element-187" data-mp="3uahmakge7zit">
            <ShieldCheck className="w-64 h-64" data-id="element-188" data-mp="3pamtgbd24zv4" />
          </div>
          <div className="relative z-10" data-id="element-189" data-mp="3ki24bn53jaxx">
            <ShieldCheck className="w-16 h-16 text-brand-500 mx-auto mb-6" data-id="element-190" data-mp="3kh0u1kvwmsh9" />
            <h2 className="text-3xl font-bold text-ink mb-6" data-id="element-191" data-mp="3fih5rdtu94lq">
              PROBALO DURANTE 7 DÍAS SIN RIESGO
            </h2>
            <p className="text-xl text-slate-300 mb-6" data-id="element-192" data-mp="gutei0ydjwg6">
              Accedé al Megapack, revisá los contenidos y empezá a aplicar las
              herramientas.
            </p>
            <p className="text-lg text-slate-400 mb-8" data-id="element-193" data-mp="2hkmhp6qlihz3">
              Si sentís que no es para vos:
              <br data-id="element-194" data-mp="2ljmxshhov6ie" />
              <strong className="text-ink" data-id="element-195" data-mp="2lk51u0alep0v">
                podés solicitar la devolución
              </strong>
              <br data-id="element-196" data-mp="27rff1tn8pg2p" />
              dentro del período de garantía.
            </p>
            <p className="text-sm text-brand-600 font-medium" data-id="element-197" data-mp="2cr1p5u7rug7a">
              Tasa de devoluciones: menos del 1%.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Este producto reemplaza una consulta médica o psicológica?',
    a: 'No. Este es un material educativo de bienestar y organización personal. No reemplaza diagnóstico, tratamiento ni acompañamiento profesional.'
  }, {
    q: '¿Necesito tener experiencia previa?',
    a: 'No. Los contenidos están explicados paso a paso y fueron pensados para principiantes.'
  }, {
    q: '¿Cuánto tiempo necesito por día?',
    a: 'Muchas de las herramientas pueden aplicarse en pocos minutos. El Plan de 30 Días te ayuda a organizarlas de forma progresiva.'
  }, {
    q: '¿Tengo que leer todos los tomos de una vez?',
    a: 'No. Podés empezar por el tomo o bono que responda mejor a lo que estás viviendo actualmente.'
  }, {
    q: '¿Cómo recibo el Megapack?',
    a: 'Después de completar el pago, recibís acceso digital inmediato a los 6 tomos y 5 bonos.'
  }, {
    q: '¿Puedo verlo desde el celular?',
    a: 'Sí. Podés acceder desde el celular, tablet o computadora.'
  }, {
    q: '¿Incluye material físico?',
    a: 'No. Todo el contenido es 100% digital.'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí. La compra incluye una garantía de 7 días. Si no estás satisfecho escribís a supportpuntodigital@gmail.com y gestionamos la devolución.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-12 px-4 bg-lav-50 pt-[4px] pb-[4px]" data-id="element-198" data-mp="umndxoxew4w2">
      <div className="max-w-3xl mx-auto" data-id="element-199" data-mp="uogkl480yp42">
        <h2 className="text-2xl md:text-3xl font-bold text-ink text-center mb-8 flex items-center justify-center gap-3" data-id="element-200" data-mp="zlgop9lbdhsj">
          <span className="text-brand-500" data-id="element-201" data-mp="14js0hpv662de">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-202" data-mp="19k6ahdgbzme2">
          {faqs.map((faq, i) => <div key={i} className="border border-lav-100 rounded-xl bg-white overflow-hidden" data-id="element-203" data-mp="1dlhpkp1kwp80" data-mpi={i}>
              <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpen(open === i ? null : i)} data-id="element-204" data-mp="1ijj9tdaqqul2">
                <span className="font-bold text-ink pr-8" data-id="element-205" data-mp="1s92umoi0kyik">{faq.q}</span>
                {open === i ? <Minus className="w-5 h-5 text-brand-500 shrink-0" data-id="element-206" data-mp="1xb1ydzho1xg1" /> : <Plus className="w-5 h-5 text-slate-500 shrink-0" data-id="element-207" data-mp="21bvnuxarbkb1" />}
              </button>
              {open === i && <div className="px-6 pb-4 text-slate-400" data-id="element-208" data-mp="2yxm6a6cmjyku">{faq.a}</div>}
            </div>)}
        </div>
      </div>
    </section>;
}
export function CostOfInaction() {
  return <section className="py-12 px-4" data-id="element-209" data-mp="33qnl6ectzy4f">
      <div className="max-w-4xl mx-auto" data-id="element-210" data-mp="33rqaihui9si8">
        <div className="text-center mb-8" data-id="element-211" data-mp="33srx9jkvw3fs">
          <h2 className="text-2xl md:text-3xl font-bold text-ink mb-4 flex items-center justify-center gap-3" data-id="element-212" data-mp="2g0b52g7fmv2r">
            <Scale className="w-9 h-9 text-lav-500" data-id="element-213" data-mp="2b31hl63lsthk" /> ¿CUÁNTO CUESTA NO EMPEZAR
            HOY?
          </h2>
        </div>

        <div className="overflow-x-auto mb-10" data-id="element-214" data-mp="2p32jmovlu6ym">
          <table className="w-full text-left border-collapse bg-white rounded-xl overflow-hidden border border-lav-100" data-id="element-215" data-mp="2k26gwemzoqus">
            <thead data-id="element-216" data-mp="4ailworjd8em">
              <tr className="border-b border-lav-100 bg-lav-50" data-id="element-217" data-mp="49z3l6xz4i02">
                <th className="p-4 text-slate-300 font-medium" data-id="element-218" data-mp="3vimpbo04m785">
                  Sin herramientas de regulación
                </th>
                <th className="p-4 text-brand-600 font-bold" data-id="element-219" data-mp="7rwlsq7yjnet">Costo real</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-lav-100" data-id="element-220" data-mp="bsyk94u1vvfq">
              <tr data-id="element-221" data-mp="3u1h7k18zlwls">
                <td className="p-4 text-slate-400" data-id="element-222" data-mp="3u28vcpwceq1i">Dormir mal cada noche.</td>
                <td className="p-4 text-ink font-medium" data-id="element-223" data-mp="2tlcqhphlgxn">
                  Cansancio que se acumula y menos energía para disfrutar tus
                  días
                </td>
              </tr>
              <tr data-id="element-224" data-mp="vjbsswaoiswe">
                <td className="p-4 text-slate-400" data-id="element-225" data-mp="vhqy96od79yj">
                  Seguir con el cuerpo en alerta.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-226" data-mp="gs1sey5buhrx">
                  Vivir con la sensación de que todo te supera
                </td>
              </tr>
              <tr data-id="element-227" data-mp="19hs65631rhni">
                <td className="p-4 text-slate-400" data-id="element-228" data-mp="19h8qjw0vd5cn">
                  Empezar el día con pensamientos acelerados.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-229" data-mp="1o5igpcebehbm">
                  Arrancar cada mañana con tensión y sin claridad
                </td>
              </tr>
              <tr data-id="element-230" data-mp="1j6ysf5c90tg3">
                <td className="p-4 text-slate-400" data-id="element-231" data-mp="1j4ckh4lg4bxc">
                  No poner límites y decir sí a todo.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-232" data-mp="1a60y5erm40ap">
                  Terminar cada día agotado y desconectado de vos
                </td>
              </tr>
              <tr data-id="element-233" data-mp="157z829vrr0pq">
                <td className="p-4 text-slate-400" data-id="element-234" data-mp="158h7ffdq9v1v">
                  Postergar una rutina simple de calma.
                </td>
                <td className="p-4 text-ink font-medium" data-id="element-235" data-mp="vgbg87vavhnq">
                  Dejar en pausa el descanso y el equilibrio que querés
                  recuperar
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-236" data-mp="mfdbfnd1f643">
          <h3 className="text-2xl font-bold text-brand-600 mb-4" data-id="element-237" data-mp="hi4tnnvsx43d">
            TU CUERPO PUEDE APRENDER A VOLVER A SENTIRSE SEGURO
            <br data-id="element-238" data-mp="2t45mkv2og2gu" />
            <span className="text-lg font-medium text-slate-300 block mt-3" data-id="element-239" data-mp="2t6rs6p60c7wf">
              No necesitás hacer todo perfecto ni cambiar tu vida de un día para
              otro. Empezá con herramientas simples, aplicalas paso a paso y
              construí una rutina que ayude a tu sistema nervioso a salir del
              estado de alerta.
            </span>
          </h3>
          <blockquote className="text-xl text-slate-300 italic border-l-4 border-brand-400 pl-6 py-2 text-left" data-id="element-240" data-mp="2afs9u6t0pwc4">
            "La calma no aparece de golpe. Se construye con pequeños hábitos que
            tu cuerpo puede repetir todos los días."
          </blockquote>
        </div>

        {/* Final CTA Block */}
        <Card glow className="bg-white border-brand-200 text-center" data-id="element-241" data-mp="2o7f4613egus9">
          <div className="inline-flex items-center gap-2 bg-brand-100 text-brand-700 border border-brand-200 px-4 py-2 rounded-full font-bold mb-8" data-id="element-242" data-mp="1qpf56qfifj0q">
            <Clock className="w-5 h-5" data-id="element-243" data-mp="p1gzz0b9cj5h" />
            EL PRECIO CIERRA EN: 23 hs : 59 min : 52 seg
          </div>

          <div className="grid md:grid-cols-1 gap-6 mb-8 max-w-md mx-auto" data-id="element-244" data-mp="k35nehtkvujk">
            <div className="p-6 border border-lav-100 rounded-xl bg-lav-50" data-id="element-245" data-mp="y2f7hskwn8st">
              <h4 className="font-bold text-ink mb-2" data-id="element-246" data-mp="y0aqqa1wqfb4">
                PUNTO DIGITAL™ — MEGAPACK REGULACIÓN DEL SISTEMA NERVIOSO
              </h4>
              <p className="text-sm text-slate-400 mb-4" data-id="element-247" data-mp="17ztaoqhti136">
                6 Tomos + 5 Bonos · Volvé a sentir calma
              </p>
              <div className="flex items-baseline justify-center gap-2 mb-6" data-id="element-248" data-mp="130yr3mc108i0">
                <span className="text-slate-500 line-through text-sm" data-id="element-249" data-mp="1hpcubydctyz3">
                  $49.000
                </span>
                <span className="text-3xl font-black text-ink" data-id="element-250" data-mp="1crtg2ygnpm75">$19.990</span>
                <span className="text-sm text-slate-400" data-id="element-251" data-mp="1qs46k0e20yrs">ARS</span>
              </div>
              <Button className="w-full" variant="outline" onClick={() => {
              window.location.href = CHECKOUT_URL;
            }} data-id="element-252" data-mp="1lsrb4r94ajdl">
                QUIERO RECUPERAR LA CALMA
              </Button>
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-slate-400" data-id="element-253" data-mp="1wc1snwvve63w">
            <span className="flex items-center" data-id="element-254" data-mp="20dx4hvbfg1vx">
              <Lock className="w-4 h-4 mr-1 text-slate-300" data-id="element-255" data-mp="20grm7f3238ln" /> Pago 100% seguro
            </span>
            <span className="flex items-center" data-id="element-256" data-mp="1ml73ajnbuqe8">
              <Zap className="w-4 h-4 mr-1 text-lav-500" data-id="element-257" data-mp="1re9zz0neifyn" /> Acceso inmediato
            </span>
            <span className="flex items-center" data-id="element-258" data-mp="1cpm5kxpakcaa">
              <ShieldCheck className="w-4 h-4 mr-1 text-brand-500" data-id="element-259" data-mp="1cqx8kvawxg0c" /> Garantía 7
              días
            </span>
            <span className="flex items-center" data-id="element-260" data-mp="1hlugfywghjbn">
              <CreditCard className="w-4 h-4 mr-1 text-lav-400" data-id="element-261" data-mp="13ph3n32va63i" /> Mercado Pago
              | Tarjeta | Transferencia
            </span>
          </div>
        </Card>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="bg-slate-950 py-10 px-4 border-t border-lav-100" data-id="element-262" data-mp="34c4aft46jgd7">
      <div className="max-w-4xl mx-auto text-center" data-id="element-263" data-mp="399w4otsarekk">
        <div className="inline-flex items-center gap-2 mb-6" data-id="element-264" data-mp="2v9lb3izlrlvp">
          <span className="text-brand-600 font-bold tracking-widest uppercase" data-id="element-265" data-mp="2vb67le5h9ew7">
            PUNTO DIGITAL™
          </span>
        </div>

        <p className="text-slate-400 mb-4 max-w-2xl mx-auto" data-id="element-266" data-mp="3ny927v7195h6">
          El Megapack Regulación del Sistema Nervioso para personas que quieren
          comprender su estrés, dormir mejor y recuperar la sensación de calma.
        </p>
        <p className="text-slate-500 mb-8 italic" data-id="element-267" data-mp="3e7ecggukvnqz">
          Porque tu cuerpo también merece una rutina que lo acompañe todos los
          días.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm text-slate-400 mb-12" data-id="element-268" data-mp="arqtfyt76szx">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-brand-600 transition-colors" data-id="element-269" data-mp="fifmhikizy16">
            supportpuntodigital@gmail.com
          </a>
          <a href="#" className="hover:text-brand-600 transition-colors" data-id="element-270" data-mp="kw73ucnwrhwc">
            www.puntodigital.store
          </a>
        </div>

        <div className="text-xs text-slate-600 space-y-2" data-id="element-271" data-mp="ym0tuyb5g87n">
          <p data-id="element-272" data-mp="tnfxj9z0q8oh">© Punto Digital™ 2026 — Todos los derechos reservados.</p>
          <p data-id="element-273" data-mp="5xvaaevu0p9e">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
          <p data-id="element-274" data-mp="1x1mdlie3agi">
            Material educativo de bienestar. No reemplaza diagnóstico ni
            tratamiento profesional.
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-lav-100" data-id="element-275" data-mp="fxm5kis7v8aj">
          <p className="text-brand-500/70 font-medium italic" data-id="element-276" data-mp="awyejx3zmrgb">
            "Esta puede ser la semana en la que tu cuerpo empiece a bajar la
            alerta."
          </p>
          <p className="text-slate-500 text-sm mt-2" data-id="element-277" data-mp="1mcn3gu0sy0jr">
            "Tu sistema nervioso puede aprender a volver a la calma."
          </p>
        </div>
      </div>
    </footer>;
}